<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="$store.state.dashboard.dashboardDialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDash">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title>Dashboard</v-toolbar-title>
        </v-toolbar>

        <div style="width: 1024px; margin: auto">
          <p v-if="!accountability" class="pt-5 mb-4 text-xs-left">
            Preencha os campos abaixo para gerar seus relatórios
          </p>

          <DocReportFiltersDash
            :getAccountabilityData="getAccountabilityData"
            :getContractStatus="getContractStatus"
            :changeTitle="() => {}"
          />
        </div>

        <div
          class="bodyReport mt-5 mx-auto pb-5"
          style="width: 1024px"
          v-if="typeDocs.length"
        >
          <v-layout row wrap>
            <v-flex xs10>
              <h2
                class="headerLine mt-1 text-xs-left primary white--text pl-2 headline font-weight-thin"
              >
                {{ $store.state.docsReports.condominiumName }}
              </h2>
            </v-flex>
            <v-flex xs2>
              <h2
                class="date headerLine text-xs-left pl-2 font-weight-light display-1 pb-1 grey--text text--darken-1"
              >
                {{
                  selectedDate ? selectedDate : new Date() | moment("MM/YYYY")
                }}
              </h2>
            </v-flex>
          </v-layout>

          <v-layout row mt-4 wrap pr-4 v-if="accountability.year">
            <v-flex xs12>
              <h2
                class="mt-5 text-xs-left pl-2 display-1 font-weight-light primary--text"
              >
                Prestação de contas
              </h2>
              <span class="underLineWtf black ml-2"></span>
            </v-flex>
            <v-flex xs4 mt-5>
              <v-avatar color="white">
                <v-icon style="border: 1px solid #ccc" color="primary"
                  >done_all</v-icon
                >
              </v-avatar>
              <div class="caption mt-1 font-weight-regular">
                Aprovação de contas
              </div>
              <div
                class="subheading mt-4 font-weight-thin grey--text text--darken-1"
              >
                Exercício
              </div>
              <h2
                class="text-xs-center font-weight-light headline pb-1 grey--text text--darken-1"
              >
                {{ accountability.year }}
              </h2>
            </v-flex>
            <v-flex xs4 mt-5>
              <v-avatar color="white">
                <v-icon style="border: 1px solid #ccc" color="primary"
                  >security</v-icon
                >
              </v-avatar>
              <div class="caption mt-1 font-weight-regular">
                Certificado digital
              </div>
              <div
                class="subheading mt-4 font-weight-thin grey--text text--darken-1"
              >
                Vencimento
              </div>
              <h2
                class="text-xs-center font-weight-light headline pb-1 grey--text text--darken-1"
              >
                {{ accountability.digital_certificated }}
              </h2>
            </v-flex>
            <v-flex xs4 mt-5>
              <v-avatar color="white">
                <v-icon style="border: 1px solid #ccc" color="primary"
                  >pending_actions</v-icon
                >
              </v-avatar>
              <div class="caption mt-1 font-weight-regular">
                Mandato de síndico
              </div>
              <h2
                style="line-height: 20px !important"
                class="mt-4 text-xs-center font-weight-light headline grey--text text--darken-1"
              >
                {{ accountability.init_period | moment("DD/MM/YYYY") }}
              </h2>
              <div class="caption font-weight-thin grey--text text--darken-1">
                a
              </div>
              <h2
                style="line-height: 20px !important"
                class="text-xs-center font-weight-light headline pb-1 grey--text text--darken-1"
              >
                {{ accountability.end_period | moment("DD/MM/YYYY") }}
              </h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap mt-5 v-if="accountability.sindication">
            <v-flex xs12 mt-4>
              <h2
                class="ml-3 modelHeaderLine text-xs-left grey lighten-4 black--text pl-5 headline font-weight-bold"
              >
                <v-avatar
                  color="white"
                  style="position: absolute; margin: -12px 0px 0px -56px"
                >
                  <v-icon style="border: 2px solid #696a6d" color="primary"
                    >local_library</v-icon
                  > </v-avatar
                >Análise das pastas
              </h2>
            </v-flex>
            <v-flex xs12 row pt-3 layout pb-2>
              <v-spacer></v-spacer>
              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="background: #757575"
              ></div>
              <span class="mr-3">Concluído</span>
              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="border: solid 2px #c62828; background-color: #fff"
              ></div>
              <span class="mr-3">Não concluído/Em processo</span>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-left caption mt-5 mb-3 pl-4 font-weight-bold">
                Analisada pela sindicância
              </div>
            </v-flex>
            <v-flex xs12>
              <v-layout align-left justify-start row fill-height pl-4>
                <div
                  v-for="(item, i) in accountability.sindication"
                  :key="i"
                  :class="[
                    i > 0 ? 'mx-3' : 'mr-3',
                    'roundedBox pa-1',
                    setStatusMonth(item.status),
                  ]"
                >
                  <div class="minDate mt-2">{{ item.month }}</div>
                  <div class="minDate">{{ item.year }}</div>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-left caption mt-4 mb-3 pl-4 font-weight-bold">
                Retorno da gerenciadora
              </div>
            </v-flex>
            <v-flex xs12>
              <v-layout align-left justify-start row fill-height pl-4>
                <div
                  v-for="(item, i) in accountability.administration"
                  :key="i"
                  :class="[
                    i > 0 ? 'mx-3' : 'mr-3',
                    'roundedBox pa-1',
                    setStatusMonth(item.status),
                  ]"
                >
                  <div class="minDate mt-2">{{ item.month }}</div>
                  <div class="minDate">{{ item.year }}</div>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-left caption mt-4 mb-3 pl-4 font-weight-bold">
                Finalizada pela sindicância
              </div>
            </v-flex>
            <v-flex xs12>
              <v-layout align-left justify-start row fill-height pl-4>
                <div
                  v-for="(item, i) in accountability.sindication_finalized"
                  :key="i"
                  :class="[
                    i > 0 ? 'mx-3' : 'mr-3',
                    'roundedBox pa-1',
                    setStatusMonth(item.status),
                  ]"
                >
                  <div class="minDate mt-2">{{ item.month }}</div>
                  <div class="minDate">{{ item.year }}</div>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-left caption mt-4 mb-3 pl-4 font-weight-bold">
                Auditoria externa anual
                <!-- <span class="primary--text">anual</span> -->
              </div>
            </v-flex>
            <v-flex xs12>
              <v-layout align-left justify-start row fill-height pl-4>
                <div
                  v-for="(item, i) in accountability.audited"
                  :key="i"
                  :class="[
                    i > 0 ? 'mx-3' : 'mr-3',
                    'roundedBox pa-1',
                    setStatusMonth(item.status, 'audited'),
                  ]"
                >
                  <div class="minDate mt-2">{{ item.month }}</div>
                  <div class="minDate">{{ item.year }}</div>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12 endLine primary mt-5></v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 mb-2>
              <h2
                class="mt-5 text-xs-left pl-2 display-1 font-weight-light primary--text"
              >
                Documentação
              </h2>
              <span class="underLineWtf black ml-2"></span>
            </v-flex>

            <v-flex xs12 mt-5>
              <h2
                class="ml-3 modelHeaderLine text-xs-left grey lighten-4 black--text pl-5 headline font-weight-bold"
              >
                <v-avatar
                  color="white"
                  style="position: absolute; margin: -12px 0px 0px -56px"
                >
                  <v-icon style="border: 2px solid #696a6d" color="primary"
                    >insert_chart_outlined</v-icon
                  > </v-avatar
                >Visão geral
              </h2>
            </v-flex>

            <v-flex xs12 row pt-3 layout pb-2>
              <v-spacer></v-spacer>

              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="background: #4caf50"
              ></div>
              <span class="mr-3">Vigentes</span>
              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="background: #ffab00"
              ></div>
              <span class="mr-3">A vencer</span>
              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="background: #c62828"
              ></div>
              <span class="mr-3">Vencidos</span>
              <div
                class="statusRounded ml-2 mr-1 mt-1"
                style="background: #696a6d"
              ></div>
              <span class="mr-3">Em obtenção</span>
            </v-flex>
          </v-layout>

          <v-layout pt-5 row wrap white pb-4 v-if="typeDocs.length">
            <v-flex
              xs12
              md4
              sm6
              mt-3
              mb-3
              v-for="(typeDoc, i) in typeDocs"
              :key="i"
            >

              <DocumentsChartsDash
                :docName="typeDoc['type_name']"
                :series="typeDoc['statuses']"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 mb-2>
              <h2
                class="mt-3 text-xs-left pl-2 display-1 font-weight-light primary--text"
              >
                Anexos
              </h2>
              <span class="underLineWtf black ml-2"></span>
            </v-flex>

            <v-flex xs12 row pt-3 layout pb-2>
              <v-spacer></v-spacer>
              <span class="mr-3 caption">
                <v-icon small class="pr-1" color="success"
                  >check_circle_outline</v-icon
                >Vigentes
              </span>
              <span class="mr-3 caption">
                <v-icon small class="pr-1" color="#ffab00">error_outline</v-icon
                >A vencer
              </span>
              <span class="mr-3 caption">
                <v-icon small class="pr-1" color="#c62828">block</v-icon
                >Vencidos
              </span>
              <span class="mr-3 caption">
                <v-icon small class="pr-1" color="##696A6D">search</v-icon
                >Em obtenção
              </span>
            </v-flex>
          </v-layout>

          <div v-if="attachments.length">
            <v-layout row wrap v-for="(doc, i) in attachments" :key="i">
              <v-flex xs12 :class="[i > 0 ? 'mt-5' : '']">
                <h2
                  class="modelHeaderLine text-xs-left grey lighten-4 black--text pl-3 headline font-weight-bold mb-5"
                >
                  {{ doc.name }}
                </h2>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="contractsTableHeader"
                  v-if="doc.name == 'CONTRATOS'"
                  hide-actions
                  :items="doc.arr"
                  class="elevation-0 documentsGrid"
                  @update:sort-by="sortTable"
                >
                  <template v-slot:items="props">
                    <tr class="miniTr">
                      <td class="text-xs-right px-0 py-1 miniTextGrid" :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]">
                        <template v-if="props.item.obtaining == 1">
                          <v-icon
                            small
                            class="pr-1"
                            color="#696A6D"
                            >search</v-icon
                          >
                        </template>
                        <template v-else>
                          <v-icon
                            v-if="props.item.status == 1"
                            small
                            class="pr-1"
                            color="success"
                            >check_circle_outline</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 2"
                            small
                            class="pr-1"
                            color="#ffab00"
                            >error_outline</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 3"
                            small
                            class="pr-1"
                            color="#c62828"
                            >block</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 4"
                            small
                            class="pr-1"
                            color="success"
                            >check_circle_outline</v-icon
                          >
                        </template>
                      </td>

                      <td
                        v-if="props.item.provider"
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]"
                      >
                        {{
                          props.item.provider
                            ? props.item.provider
                            : props.item.sub_type
                        }}
                      </td>

                      <td

                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]"
                      >
                        {{
                          props.item.service
                            ? props.item.service
                            : props.item.sub_type
                        }}
                      </td>

                      <td
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-center miniTextGrid py-1',
                        ]"
                      >
                        {{ props.item.validate_date | moment("DD/MM/YYYY") }}
                      </td>

                      <td
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid',
                        ]"
                      >
                        {{ props.item.price | formatCurrency }}
                      </td>

                      <td
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-center miniTextGrid py-1',
                        ]"
                      >
                        {{ props.item.early_warning }}
                      </td>

                      <td
                        style="max-width: 400px"
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1 pr-1',
                        ]"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">

                            <span
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{ props.item.observation }}
                            </span>
                          </template>
                          <span>{{ props.item.observation }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-data-table
                  v-else
                  :headers="genericHeaders"
                  hide-actions
                  :items="doc.arr"
                  class="elevation-0 documentsGrid"
                  @update:sort-by="sortTable"
                >
                  <template v-slot:items="props">
                    <tr class="miniTr">
                      <td class="text-xs-right px-0 py-1 miniTextGrid" :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]">
                        <template v-if="props.item.obtaining == 1">
                          <v-icon
                            small
                            class="pr-1"
                            color="#696A6D"
                            >search</v-icon
                          >
                        </template>
                        <template v-else>
                          <v-icon
                            v-if="props.item.status == 1"
                            small
                            class="pr-1"
                            color="success"
                            >check_circle_outline</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 2"
                            small
                            class="pr-1"
                            color="#ffab00"
                            >error_outline</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 3"
                            small
                            class="pr-1"
                            color="#c62828"
                            >block</v-icon
                          >
                          <v-icon
                            v-if="props.item.status == 4"
                            small
                            class="pr-1"
                            color="success"
                            >check_circle_outline</v-icon
                          >
                        </template>
                      </td>

                      <td
                        style="min-width: 300px"
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]"
                      >
                        {{
                          props.item.service
                            ? props.item.service
                            : props.item.sub_type
                        }}
                      </td>

                      <td
                        v-if="props.item.provider"
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1',
                        ]"
                      >
                        {{
                          props.item.provider
                            ? props.item.provider
                            : props.item.sub_type
                        }}
                      </td>

                      <td
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-center miniTextGrid py-1',
                        ]"
                      >
                        {{ props.item.validate_date | moment("DD/MM/YYYY") }}
                      </td>

                      <td
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-center miniTextGrid py-1',
                        ]"
                      >
                        {{ props.item.early_warning }}
                      </td>

                      <td
                        style="max-width: 400px"
                        :class="[
                          props.index % 2 == 0 ? 'bgTdGrey' : '',
                          'text-xs-left miniTextGrid py-1 pr-1',
                        ]"
                      >
                        {{ props.item.observation }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import DocReportFiltersDash from '@/components/dashboard/DocReportFiltersDash'
import DocumentsChartsDash from '@/components/dashboard/DocumentsChartsDash'
import { accountabilityData, reportsDocs } from '@/services/dashboard'

export default {
  name: 'Dashboard',

  components: { DocReportFiltersDash, DocumentsChartsDash },

  data () {
    return {
      attachments: [],
      selectedDate: '',
      typeDocs: [],
      accountability: null,
      contractsTableHeader: [
        {
          class: 'miniHeaderGrid',
          text: '',
          align: 'center',
          sortable: false,
          value: 'status'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Empresa',
          align: 'left',
          sortable: false,
          value: 'provider'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Serviço',
          align: 'left',
          sortable: false,
          value: 'service'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Vencimento',
          align: 'center',
          sortable: false,
          value: 'validate_date'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Valor',
          align: 'left',
          sortable: false,
          value: 'validate_date'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Aviso vcto.',
          align: 'center',
          sortable: false,
          value: 'alert_date'
        },
        {
          class: 'miniHeaderGrid',
          text: 'Observações',
          align: 'left',
          sortable: false,
          value: 'observation'
        }
      ],
      genericHeaders: [
        {
          class: 'miniHeaderGrid',
          text: '',
          align: 'center',
          sortable: false
          // value: "name",
        },
        {
          class: 'miniHeaderGrid',
          text: 'Documento',
          align: 'left',
          sortable: false
          // value: "name",
        },
        {
          class: 'miniHeaderGrid',
          text: 'Vencimento',
          align: 'center',
          sortable: false
          // value: "name",
        },
        {
          class: 'miniHeaderGrid',
          text: 'Aviso vcto.',
          align: 'center',
          sortable: false
          // value: "name",
        },
        {
          class: 'miniHeaderGrid',
          text: 'Observações',
          align: 'left',
          sortable: false
          // value: "name",
        }
      ]
    }
  },

  mounted () {
    setTimeout(() => {
      this.$store.commit('dashboard/updateDashboardDialog', true)
    }, 300)
  },

  beforeRouteEnter (to, from, next) {
    next((_this) => {
      if (!from.name) { _this.$store.commit('dashboard/updateDashboardDialog', true) }
    })
  },

  computed: {
    attachmentArr () {
      return this.$store.state.docsReports.completDocList
    }
  },

  watch: {
    attachmentArr (v, o) {
      if (v.length && v.length === this.typeDocs.length) {
        var newArr = [...v]
        this.attachments = [...this.mapOrder(newArr, 'name')]
      }
    }
  },

  methods: {
    mapOrder (array, key) {
      var order = this.typeDocs.map((i) => i.type_name)
      array.sort(function (a, b) {
        var A = a[key]
        var B = b[key]

        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })
      return array
    },

    setStatusMonth (v, audited) {
      if (audited === 'audited') {
        if (v === 1) {
          return 'finished'
        } else {
          return 'running'
        }
      }
      if (v === 1) {
        return 'disab'
      } else if (v === 2) {
        return 'running'
      } else {
        return 'finished'
      }
    },

    sortTable (event) {
      console.log('Event: ', event)
    },

    async getAccountabilityData (data) {
      this.selectedDate = data.date_end

      let query = {
        id: data.condominium_id,
        reference_date: data.date_end
      }

      const response = await accountabilityData(query)

      if (!response) {
        this.accountability = {}
      } else {
        this.accountability = response
      }
    },

    async getContractStatus (data, cbo) {
      let stop = false
      this.typeDocs = []

      if (!data.condominium_id) {
        cbo.focus()
        return
      }

      // this.$store.state.docsReports.condominiumId = data.condominium_id;
      this.$store.commit('docsReports/updateSearchData', {
        id: data.condominium_id,
        date_init: data.date_init,
        date_end: data.date_end
      })

      const response = await reportsDocs(data)

      let charts = response.filter((type) => {
        if (type.statuses[0] || type.statuses[1] || type.statuses[2] || type.statuses[3]) {
          return type
        }
      })

      let categories = charts.map((ctg) => {
        let obj = {}
        obj.type_id = ctg.type_id
        obj.type_name = ctg.type_name
        return obj
      })

      this.$store.commit('docsReports/updateCboTypeDocs', categories)

      this.typeDocs = [...charts]

      if (!this.typeDocs.length) {
        stop = true

        let obj = {
          message: `Não há dados para gerar o relatório`,
          title: 'Dashboard',
          type: 'warning',
          btConfirm: { name: 'Ok', show: true },
          btCancel: { name: 'Não', show: false }
        }
        
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      }

      this.getAttachments()

      return stop
    },

    getAttachments () {
      this.typeDocs.map(doc => {
        // this.$store.commit("docsReports/updateDialogShow", true);
        this.$store.commit('docsReports/updateDocTypeSel', {
          docName: doc.type_name,
          status: '',
          type_id: doc.type_id
        })
        // console.log(this.docName);
        this.$store.dispatch(
          'docsReports/getDocDetailsFromCompletList',
          doc.type_name
        )
      })
    },

    closeDash () {
      this.$router.back()
      // setTimeout(() => {
      this.$store.commit('dashboard/updateDashboardDialog', false)
      // }, 500);
    }
  },

  filters: {
    formatCurrency (value) {
      if (value) {
        return value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })
      }

      return 'R$ 0,00'
    }
  }
}
</script>

<style>
.documentsGrid table.v-table thead tr {
  height: auto !important;
}
.miniHeaderGrid {
  padding-bottom: 0;
  font-weight: bold;
}
tr.miniTr {
  border-top: 3px solid #fff !important;
  border-bottom: 3px solid #fff !important;
}
.bgTdGrey {
  background: #f0f0f0 !important;
}
table.v-table tbody td.miniTextGrid {
  font-size: 12px;
  height: auto;
}
.statusRounded {
  height: 12px;
  border-radius: 50px;
  width: 12px;
  /* margin-top: 1px; */
}
.endLine {
  height: 2px;
}
.roundedBox.disab {
  /* border: 1px solid #c62828; */
  background: #fff;
  color: rgb(204, 204, 204);
}
.roundedBox.running {
  border: 1px solid #c62828;
  background: #fff;
  color: #c62828;
}
.roundedBox.finished {
  border: 1px solid #757575;
  background: #757575;
  color: #fff;
}
.roundedBox {
  border: 1px solid rgb(204, 204, 204);
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.minDate {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
}
.modelHeaderLine {
  font-size: 18px !important;
  text-transform: uppercase;
}
.headerLine {
  font-size: 20px !important;
  text-transform: uppercase;
}
.headerLine.date {
  font-size: 30px !important;
}
.underLineWtf {
  height: 2px;
  width: 65px;
  display: block;
}
</style>
